export const productTypes = {
  lesson: 'lesson',
  package: 'package',
  artist: 'artist'
};

export const productTypesArray = [productTypes.lesson, productTypes.package, productTypes.artist];
